import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import { FiltersMenu, FiltersSubMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconWorld from '@/icons/World.svg';

import { ROLE_LIST_SCOPE_KEYS, useRoleListScopeLabels } from '../../scope-labels';
import { useFilters } from '../FiltersState';

export const FiltersScope = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();
  const scopeLabels = useRoleListScopeLabels();

  const {
    scopes: { scopes, setScopes },
  } = useFilters();

  const options = ROLE_LIST_SCOPE_KEYS.map((id) => (
    <FilterCheckboxItem
      key={id}
      checked={scopes.includes(id)}
      onChange={(checked) => {
        if (checked) {
          setScopes([...scopes, id]);
        } else {
          setScopes(scopes.filter((s) => s !== id));
        }
      }}
    >
      {scopeLabels[id]}
    </FilterCheckboxItem>
  ));

  if (tag) {
    if (scopes.length === 0) {
      return null;
    }

    const numberOfScopes = scopes.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({
              id: 'settings.organization.roles.filters.scope.label',
              message: 'Scope',
            })}
            value={
              scopes.length === 1 ? (
                scopeLabels[scopes[0]]
              ) : (
                <Trans id="settings.organization.roles.filters.scope.multiple">
                  {numberOfScopes} scopes
                </Trans>
              )
            }
            tooltip={scopes.length > 1 ? scopes.map((s) => scopeLabels[s]).join(', ') : undefined}
            onClear={() => setScopes([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconWorld />}
      label={t({
        id: 'settings.organization.roles.filters.scope.label',
        message: 'Scope',
      })}
    >
      {options}
    </FiltersSubMenu>
  );
};
